import { ComponentImageType } from 'models';

type ComponentImage = { file?: unknown; type?: string | null };

const ComponentImageHelpers = {
    thumbnail: <Image extends ComponentImage>(images: Image[] | null | undefined): Image | undefined =>
        ComponentImageHelpers.withThumbnailFirst(images)[0],

    withThumbnailFirst: <Image extends ComponentImage>(images: Image[] | null | undefined) => {
        const imagesWithFile = (images ?? []).filter((image) => image.file);
        const isThumbnail = (image: Image) => image.type === ComponentImageType.THUMBNAIL;

        return [...imagesWithFile.filter(isThumbnail), ...imagesWithFile.filter((image) => !isThumbnail(image))];
    },
};

export { ComponentImageHelpers };
